import http from '../../../utils/services/http'

export const list = (limit, page, filtros) => {
    let url = `/api/negocios?page=${page}&limit=${limit}${filtros}`
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const listByFunil = (funil, limit, page, filtros) => {
    let url = `/api/funils/${funil}/negocios?page=${page}&limit=${limit}${filtros}`
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const find = (id = null) => {
    let url
    if (id) {
        url = `/api/negocios/${id}`
    } else {
        url = `/api/negocios/default`
    }
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const newNegocio = (data) => {
    let url = `/api/negocios`
    return http.post(url, data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const updateNegocio = (id, data) => {
    let url = `/api/negocios/${id}`
    return http.put(url, data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}
